<div class="modal-header-modern">
    <div class="modal-header-icon icon-green">
        <i class="material-icons">assignment</i>
    </div>
    <div>
        <h4 class="modal-title-modern">{{ preenchidoId ? 'Editar Preenchimento' : 'Preencher Formulário' }}</h4>
        <p class="modal-subtitle-modern">Responda as perguntas do formulário</p>
    </div>
    <button type="button" class="modal-close-btn" aria-label="Close" (click)="cancelar()">
        <i class="material-icons">close</i>
    </button>
</div>

<div class="modal-body" *ngIf="!loading && formulario">
    <div class="formulario-info">
        <h6 class="formulario-nome">{{ formulario.nome }}</h6>
        <p class="formulario-descricao" *ngIf="formulario.descricao">{{ formulario.descricao }}</p>
    </div>

    <div *ngFor="let pergunta of formulario.perguntas; let i = index" class="pergunta-item">
        <label class="pergunta-label">
            <span class="pergunta-numero">{{ i + 1 }}</span>
            {{ pergunta.texto }}
            <span class="obrigatoria-badge" *ngIf="pergunta.obrigatoria">Obrigatória</span>
        </label>

        <!-- Texto Curto -->
        <input *ngIf="pergunta.tipoPergunta === TipoPergunta.TextoCurto"
            type="text" class="form-control-modern"
            [(ngModel)]="respostas[pergunta.id]"
            placeholder="Digite sua resposta...">

        <!-- Texto Longo -->
        <textarea *ngIf="pergunta.tipoPergunta === TipoPergunta.TextoLongo"
            class="form-control-modern" rows="3"
            [(ngModel)]="respostas[pergunta.id]"
            placeholder="Digite sua resposta..."></textarea>

        <!-- Escolha Única -->
        <div *ngIf="pergunta.tipoPergunta === TipoPergunta.EscolhaUnica" class="opcoes-container">
            <div class="opcao-card" *ngFor="let opcao of getOpcoes(pergunta)"
                [class.opcao-selecionada]="respostas[pergunta.id] === opcao"
                (click)="respostas[pergunta.id] = opcao">
                <div class="opcao-radio">
                    <div class="opcao-radio-inner"></div>
                </div>
                <span class="opcao-texto">{{ opcao }}</span>
            </div>
        </div>

        <!-- Escolha Múltipla -->
        <div *ngIf="pergunta.tipoPergunta === TipoPergunta.EscolhaMultipla" class="opcoes-container">
            <div class="opcao-card opcao-checkbox" *ngFor="let opcao of getOpcoes(pergunta)"
                [class.opcao-selecionada]="isMultiplasSelecionadas(pergunta.id, opcao)"
                (click)="toggleMultipla(pergunta.id, opcao)">
                <div class="opcao-check">
                    <i class="material-icons" *ngIf="isMultiplasSelecionadas(pergunta.id, opcao)">check</i>
                </div>
                <span class="opcao-texto">{{ opcao }}</span>
            </div>
        </div>

        <!-- Sim/Não -->
        <div *ngIf="pergunta.tipoPergunta === TipoPergunta.SimNao" class="opcoes-container opcoes-inline">
            <div class="opcao-card opcao-sim-nao"
                [class.opcao-selecionada]="respostas[pergunta.id] === 'Sim'"
                (click)="respostas[pergunta.id] = 'Sim'">
                <i class="material-icons opcao-icon-sim">check_circle</i>
                <span class="opcao-texto">Sim</span>
            </div>
            <div class="opcao-card opcao-sim-nao"
                [class.opcao-selecionada]="respostas[pergunta.id] === 'Não'"
                (click)="respostas[pergunta.id] = 'Não'">
                <i class="material-icons opcao-icon-nao">cancel</i>
                <span class="opcao-texto">Não</span>
            </div>
        </div>

        <!-- Escala -->
        <div *ngIf="pergunta.tipoPergunta === TipoPergunta.Escala" class="escala-container">
            <span class="escala-label">{{ pergunta.escalaMinimo }}</span>
            <input type="range" class="form-range-modern"
                [min]="pergunta.escalaMinimo" [max]="pergunta.escalaMaximo"
                [(ngModel)]="respostas[pergunta.id]">
            <span class="escala-label">{{ pergunta.escalaMaximo }}</span>
            <span class="escala-valor">{{ respostas[pergunta.id] || pergunta.escalaMinimo }}</span>
        </div>

        <!-- Data -->
        <input *ngIf="pergunta.tipoPergunta === TipoPergunta.Data"
            type="date" class="form-control-modern"
            [(ngModel)]="respostas[pergunta.id]">

        <!-- Número -->
        <input *ngIf="pergunta.tipoPergunta === TipoPergunta.Numero"
            type="number" class="form-control-modern"
            [(ngModel)]="respostas[pergunta.id]"
            placeholder="Digite um número...">
    </div>
</div>

<div class="modal-body text-center py-5" *ngIf="loading">
    <ngx-loading [show]="loading"></ngx-loading>
</div>

<div class="modal-footer-modern">
    <button type="button" class="btn-modern btn-modern-outline" (click)="cancelar()">
        <i class="material-icons">close</i> Cancelar
    </button>
    <button type="button" class="btn-modern btn-modern-success" (click)="confirmar()" [disabled]="loading">
        <i class="material-icons">check</i> Salvar
    </button>
</div>
